var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _vm.rooms.settings == ""
        ? _c(
            "v-card",
            {
              staticClass: "rounded-lg fill-height",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "fill-height" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "fill-height",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-col", [
                        _c(
                          "div",
                          { staticClass: "text-h1" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "error--text text--disabled",
                                staticStyle: { "font-size": "1.5em" },
                              },
                              [_vm._v("mdi-alert")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-h6 grey--text darken-4 text-center",
                          },
                          [_vm._v("100ms Settings Missing")]
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "max-width": "500px",
                                  margin: "auto",
                                },
                              },
                              [
                                _vm._v(
                                  "You will need to update the 100ms settings before you can create a meeting room."
                                ),
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "my-8",
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push("/admin/100ms")
                                  },
                                },
                              },
                              [_vm._v("Go to 100ms Settings")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.rooms.rooms.length == 0 && !_vm.rooms.loading
        ? _c(
            "v-card",
            {
              staticClass: "rounded-lg fill-height",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "fill-height" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "fill-height",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-col", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-h6 grey--text darken-4 text-center",
                          },
                          [_vm._v("No Rooms Yet")]
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "max-width": "500px",
                                  margin: "auto",
                                },
                              },
                              [
                                _vm._v(
                                  "Rooms are where you hold your online meetings. A room can have different settings for branding, content, and other behaviours based on your needs."
                                ),
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "my-8",
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push("/admin/rooms/new")
                                  },
                                },
                              },
                              [_vm._v("Create a Meeting Room")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.rooms.rooms.length > 0
        ? _c(
            "div",
            [
              _c(
                "v-row",
                [
                  _vm._l(_vm.rooms.rooms, function (room) {
                    return _c(
                      "v-col",
                      {
                        key: room.ID,
                        staticClass: "d-flex flex-column",
                        attrs: { cols: "12", sm: "6", lg: "3", xl: "2" },
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass:
                              "elevation-5 flex d-flex flex-column rounded-lg",
                            attrs: {
                              color: room.settings
                                ? room.settings.background_color.hex
                                : "",
                              dark: room.settings ? room.settings.dark : false,
                              light: room.settings ? !room.settings.dark : true,
                            },
                          },
                          [
                            _c(
                              "v-card-title",
                              {
                                staticClass: "pa-4",
                                style: `background-color:${_vm.rooms.roomHeaderColor(
                                  room
                                )};min-height:120px;`,
                                attrs: { "min-height": "120" },
                              },
                              [
                                room.settings && room.settings.header_logo
                                  ? _c("v-img", {
                                      attrs: {
                                        src: room.settings.header_logo,
                                        contain: "",
                                        "max-height": "75",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-card-title",
                              { staticClass: "font-weight-bold" },
                              [
                                _c("span", { staticClass: "pr-2" }, [
                                  _vm._v(_vm._s(room.post_title)),
                                ]),
                              ]
                            ),
                            _c("v-card-text", { staticClass: "flex" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    room.settings
                                      ? room.settings.description
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "v-card-actions",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      color: _vm.rooms.roomPrimaryColor(room),
                                      href: `/${room.post_name}`,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(" Join ")]
                                ),
                                _c("v-spacer"),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push(
                                          `/admin/rooms/${room.ID}`
                                        )
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-cog")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-column",
                      attrs: { cols: "12", sm: "6", lg: "3", xl: "2" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "elevation-5 fill-height d-flex flex-column align-center justify-center rounded-lg",
                          attrs: { "min-height": "275" },
                        },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-h5 font-weight-bold mb-4",
                                },
                                [_vm._v("New Room")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    "x-large": "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push(
                                        `/admin/rooms/new`
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { "x-large": "" } }, [
                                    _vm._v("mdi-plus"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }